// src/pages/GalleriesPhotos/CreateAlbumModal.jsx
import React, { useState } from "react";
import { FaSave, FaTimes } from "react-icons/fa";
import Button from "./../../components/Button/Button";
import { addGallery } from "./../../services/gallerieServices";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";

const CreateAlbumModal = ({ isOpen, onClose, refreshList }) => {
  const [formData, setFormData] = useState({
    titre: "",
    description: "",
    is_active: true,
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addGallery(formData);
      await refreshList();
      onClose();
      setFormData({ titre: "", description: "", is_active: true });
      toast.success("Album créé avec succès.");
    } catch (error) {
      console.error("Erreur lors de la création de l'album", error);
      toast.error("Erreur lors de la création de l'album.");
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50">
      <div className="w-full max-w-lg bg-white dark:bg-slate-900 dark:text-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-primary via-indigo-500 to-cyan-500 px-5 py-3 flex items-center justify-between">
          <h3 className="text-lg font-bold uppercase text-white tracking-[0.18em]">
            Créer un Album
          </h3>
          <button
            type="button"
            onClick={handleCancel}
            className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-black/40 text-white hover:bg-black/70"
          >
            <FaTimes />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-5 space-y-4">
          <div>
            <label className="block text-xs font-semibold mb-1 uppercase tracking-[0.18em] text-slate-600 dark:text-slate-300">
              Titre de l'album
            </label>
            <input
              type="text"
              name="titre"
              value={formData.titre}
              onChange={handleChange}
              className="input input-bordered w-full dark:bg-slate-800 dark:border-slate-700 dark:text-white"
              required
            />
          </div>

          <div>
            <label className="block text-xs font-semibold mb-1 uppercase tracking-[0.18em] text-slate-600 dark:text-slate-300">
              Description
            </label>
            <ReactQuill
              value={formData.description}
              onChange={(content) =>
                setFormData((prev) => ({ ...prev, description: content }))
              }
              className="bg-white dark:bg-slate-800 rounded-md overflow-hidden"
            />
          </div>

          <label className="flex items-center gap-2 mt-2 text-sm">
            <input
              type="checkbox"
              name="is_active"
              checked={formData.is_active}
              onChange={handleChange}
              className="checkbox checkbox-primary"
            />
            <span>Album actif (visible par le public)</span>
          </label>

          <div className="flex justify-center gap-3 pt-2">
            <Button
              text="Enregistrer"
              icon={FaSave}
              type="submit"
              className="gap-2"
            />
            <Button
              text="Annuler"
              icon={FaTimes}
              onClick={handleCancel}
              type="button"
              className="gap-2 btn-ghost"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateAlbumModal;
